import React from "react";
import { generateTourPDFCSS } from "../../../controllers/cssController";
import BnplFreezePDFHeaderStatic from "./BnplFreezePDFHeaderStatic";
import BnplFreezePDFOrderSummaryStatic from "./BnplFreezePDFOrderSummaryStatic";
import BnplFreezePDFItineraryStatic from "./BnplFreezePDFItineraryStatic";
import BnplFreezePDFPassengersStatic from "./BnplFreezePDFPassengersStatic";
import BnplFreezePDFPaymentStatic from "./BnplFreezePDFPaymentStatic";
import BnplFreezePDFFooterStatic from "./BnplFreezePDFFooterStatic";

/**
 * Combines BNPL freeze static PDF sections into one printable document.
 * Pass { priceFreeze, detail, flight } from single-price-freeze API.
 * Markup is table + Tailwind oriented for Adobe/HTML→PDF rendering.
 */
export default function BnplFreezeConfirmationPDFSection({ data }) {
  const freeze = data?.priceFreeze;
  const detail = data?.detail;
  const flight = data?.flight;

  const header = BnplFreezePDFHeaderStatic({ freeze, flight, detail });
  const orderSummary = BnplFreezePDFOrderSummaryStatic({ freeze, flight });
  const itinerary = BnplFreezePDFItineraryStatic({ flight });
  const passengers = BnplFreezePDFPassengersStatic({ flight });
  const payment = BnplFreezePDFPaymentStatic({ freeze, detail, flight });
  const footer = BnplFreezePDFFooterStatic({ freeze, detail, flight });

  const combinedStaticMarkup = `
    <table class="w-full bg-white text-gray-800" cellpadding="0" cellspacing="0" style="font-family: Arial, Helvetica, sans-serif; max-width: 800px; margin: 0 auto;">
      <tbody>
        <tr>
          <td class="p-6">
            ${header}
            ${orderSummary}
            ${itinerary}
            ${passengers}
            ${payment}
            ${footer}
          </td>
        </tr>
      </tbody>
    </table>
  `;

  return (
    <div className="bnpl-freeze-doc-template">
      <div dangerouslySetInnerHTML={{ __html: combinedStaticMarkup }} />
      <style>{generateTourPDFCSS()}</style>
    </div>
  );
}
